import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { SiteSettingsApi } from "../api/AdminApi";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import SiteSettingAddDialog from "./SiteSettingAddDialog";
import { getData } from "../api/AuthenticatedApiCaller";

export default function SiteSettings() {
  const [editedSetting, setEditedSetting] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [siteSettings, setSiteSettings] = useState(null);
  const [error, setError] = useState(false);
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    if (siteSettings === null || update) {
      fetchData();
    }
    setUpdate(false);
  }, [update]);

  async function fetchData() {
    const [data, error] = await getData(SiteSettingsApi.getAllSiteSettings);
    if (error) {
      // Handle the error
    } else {
      setSiteSettings(data);
    }
  }

  return (
    <Box>
      {editedSetting !== null && (
        <SiteSettingAddDialog
          open={isDialogOpen}
          setting={editedSetting}
          save={() => {
            setIsDialogOpen(false);
            setUpdate(true);
          }}
          cancel={() => setIsDialogOpen(false)}
        />
      )}

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow id="header">
              <TableCell>Id</TableCell>
              <TableCell>Name</TableCell>
              {siteSettings !== null &&
                siteSettings["languages"].map((language) => (
                  <TableCell>{language}</TableCell>
                ))}
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {siteSettings !== null &&
              siteSettings["data"].map((setting) => (
                <TableRow key={setting.id}>
                  <TableCell>{setting.id}</TableCell>
                  <TableCell>{setting.name}</TableCell>
                  {setting.contents.map((content) => (
                    <TableCell>{content.text}</TableCell>
                  ))}
                  <TableCell>
                    <IconButton>
                      <EditIcon
                        onClick={() => {
                          setEditedSetting(setting);
                          setIsDialogOpen(true);
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
